import {
  TWO_FACTOR_ATTEMPT,
  TWO_FACTOR_SUCCESS,
  TWO_FACTOR_FAILED,
  TWO_FACTOR_UPDATE_SUCCESS,
  TWO_FACTOR_UPDATE_FAILED,
  TWO_FACTOR_SETUP_SUCCESS,
  TWO_FACTOR_SEND_SUCCESS,
} from "../types/twoFactorTypes";
import { getDefaultTwoFactorSettings } from "../../assets/lang/twoFactorUtils";

const INITIAL_STATE = {
  loading: false,
  settings: getDefaultTwoFactorSettings(),
  error: "",
  error_update: "",
  codeSent: false,
  qrReady: false,
};

function twoFactor(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TWO_FACTOR_ATTEMPT:
      return { ...state, loading: true, error: "" };

    case TWO_FACTOR_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: action.data,
        error: "",
        codeSent: false,
        qrReady: Boolean(action.data.otpauthUrl),
      };

    case TWO_FACTOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case TWO_FACTOR_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: {
          ...state.settings,
          ...action.data,
          otpauthUrl: action.data.enabled ? state.settings.otpauthUrl : "",
        },
        error_update: "",
        codeSent: false,
        qrReady: action.data.enabled ? state.qrReady : false,
      };

    case TWO_FACTOR_UPDATE_FAILED:
      return {
        ...state,
        loading: false,
        error_update: action.error,
      };

    case TWO_FACTOR_SEND_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: { ...state.settings, ...action.data },
        codeSent: true,
        error_update: "",
      };

    case TWO_FACTOR_SETUP_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: { ...state.settings, ...action.data },
        qrReady: true,
        error_update: "",
      };

    default:
      return state;
  }
}

export default twoFactor;
